// extracted by mini-css-extract-plugin
module.exports = {"title":"Faq_title__1sBLJ","nav":"Faq_nav__3h2fp","btn":"Faq_btn__2vmCu","active":"Faq_active__5GT88","dropdown":"Faq_dropdown__1tq4-","list":"Faq_list__1pIOL"};